import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Create } from "../Create";
import { Store, StoreContext } from "../store";

export const CreateModule = observer(function CreateModule() {
  const appStore = useStore();
  const [store] = useState(() => new Store(appStore, FormMode.CREATE));
  return (
    <StoreContext.Provider value={store}>
      <Create />
    </StoreContext.Provider>
  );
});
